// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function checkPhoneValid(input, country) {
  const __x = input.current;
  const value = Belt__Belt_Option.map((__x == null) ? undefined : Caml_option.some(__x), (function (el) {
    return el.value;
  }));
  const phoneRE = country === /* COUNTRY_KAZ */ 1 ? /\d{10}/ : /\d{9}/;
  if (value !== undefined) {
    const phone = Caml_option.valFromOption(value).replace(/\D/g, "");
    const match = phone.match(phoneRE);
    if (match !== null) {
      const __x$1 = input.current;
      Belt__Belt_Option.map((__x$1 == null) ? undefined : Caml_option.some(__x$1), (function (el) {
        return el.setCustomValidity("");
      }));
      return true;
    }
    const __x$2 = input.current;
    Belt__Belt_Option.map((__x$2 == null) ? undefined : Caml_option.some(__x$2), (function (el) {
      return el.setCustomValidity("Неправильный номер телефона");
    }));
    return false;
  }
  const __x$3 = input.current;
  Belt__Belt_Option.map((__x$3 == null) ? undefined : Caml_option.some(__x$3), (function (el) {
    return el.setCustomValidity("Неправильный номер телефона");
  }));
  return false;
}

const countries_0 = {
  code: /* COUNTRY_KAZ */ 1,
  icon: JsxRuntime.jsx("img", {
    className: "inline mr-4",
    src: StaticAsset.src("/static/icons/kazakhstan-round.svg")
  })
};

const countries = {
  hd: countries_0,
  tl: /* [] */ 0
};

export {
  checkPhoneValid,
  countries,
}
/* countries Not a pure module */
